import {ajaxurl, createElementAnd, raf} from "./util";

export function registerSearch() {
    raf(() => {
        const searchElement = document.querySelector("[data-search]");

        if (searchElement === null)
            return;

        new Search(searchElement);
    });
}

export class Search {

    constructor(el) {
        this.el = {};
        this.el.root = el;
        this.el.field = el.querySelector("[data-search-field]");
        this.el.fieldContainer = el.querySelector("[data-search-field-container]");
        this.el.suggestions = el.querySelector("[data-search-suggestions]");
        this.el.suggestionsInfo = this.el.suggestions.querySelector("[data-search-info]");
        this.el.suggestionsResults = this.el.suggestions.querySelector("[data-search-results]");

        this.currentSearchRequest = null;

        Array.prototype.slice.call(document.querySelectorAll("[data-live-search-close")).forEach(el => el.addEventListener("click", evt => this.close(evt)));
        Array.prototype.slice.call(document.querySelectorAll("[data-live-search-open")).forEach(el => el.addEventListener("click", evt => this.open(evt)));

        this.el.field.addEventListener("keydown", () => this.onFieldChange());
        this.el.field.addEventListener("keyup", () => this.onFieldChange());

        this.toggleSuggestionsInfo(true);
        this.toggleSuggestionsResults(false);
    }

    close(evt) {
        evt.preventDefault();

        document.body.classList.remove("is-searching");
        this.el.field.value = "";

        this.toggleSuggestionsInfo(true);
        this.toggleSuggestionsResults(false);
    }

    open(evt) {
        evt.preventDefault();

        document.body.classList.add("is-searching");

        raf(() => this.el.field.focus());
    }

    toggleSuggestionsInfo(show = false) {
        this.el.suggestionsInfo.style.setProperty("display", show ? "block" : "none");
    }

    toggleSuggestionsResults(show = false) {
        this.el.suggestionsResults.style.setProperty("display", show ? "block" : "none");

        if (!show)
            this.el.suggestionsResults.innerHTML = "";
    }

    onFieldChange() {
        const searchQuery = this.el.field.value.trim();

        if (this.currentSearchRequest !== null)
            this.currentSearchRequest.abort();

        if (searchQuery.length < 3) {
            this.toggleSuggestionsInfo(true);
            this.toggleSuggestionsResults(false);
            return;
        }

        this.el.fieldContainer.classList.add("is-loading");

        const searchParams = {
            action: "search",
            q: searchQuery
        };

        this.currentSearchRequest = jQuery.post(ajaxurl, searchParams, res => this.onResponse(res));
    }

    onResponse(response) {
        this.toggleSuggestionsResults(false);

        this.el.fieldContainer.classList.remove("is-loading");
        this.currentSearchRequest = null;

        for (let group of Object.values((response.data.search_results || {}))) {
            let groupHeader = createElementAnd("div", div => div.classList.add("search-results-group-title", "mt-2", "ml-1"));
            let groupResults = createElementAnd("div", div => div.classList.add("search-suggestion-group", `search-suggestion-${group.type}`, "overview", "boxed-overview", "overview-flex", `columns-${group.columns}`));

            groupHeader.innerHTML = `<h4 style="color: white">${group.label}</h4>`;

            if (group.type === "accommodation") {
                for (let result of group.results) {
                    const box = createElementAnd("div", div => div.classList.add("box"));
                    box.innerHTML = `<div class="overview-item overview-item-camping"><header><a href="${result.permalink}">${result.name}</a><small>${result.data.camping.name}</small></header><a href="${result.permalink}"><figure><div class="overview-photo" id="first" style="background-image: url(${result.data.featured_image})"></div><div class="overview-photo" id="second" style="background-image: url(${result.data.featured_image_hover})"></div></figure></a><footer class="text-right"><a class="btn btn-sm btn-secondary" href="${result.permalink}">${result.data.button}</a></footer></div>`;

                    groupResults.appendChild(box);
                }
            } else if (group.type === "camping") {
                for (let result of group.results) {
                    const box = createElementAnd("div", div => div.classList.add("box"));
                    box.innerHTML = `<div class="overview-item overview-item-camping"><header><a href="${result.permalink}">${result.name}</a><small>${result.data.sub_title}</small></header><a href="${result.permalink}"><figure><div class="overview-photo" id="first" style="background-image:url(${result.data.featured_image})"></div><div class="overview-photo" id="second" style="background-image:url(${result.data.featured_image_hover})"></div></figure></a><footer class="text-right"><a class="btn btn-sm btn-secondary" href="${result.permalink}">${result.data.button}</a></footer></div>`;

                    groupResults.appendChild(box);
                }
            } else {
                groupResults.classList.remove("overview", "boxed-overview", "overview-flex");
                groupResults.classList.add("search-results", "mx-0");

                for (let result of group.results) {
                    const box = createElementAnd("div", div => div.classList.add("box"));
                    box.innerHTML = `<a class="search-result" href="${result.permalink}"><h4>${result.name}</h4><small>${result.permalink}</small><p>${result.data.excerpt}</p></a>`;

                    groupResults.appendChild(box);
                }
            }

            this.el.suggestionsResults.appendChild(groupHeader);
            this.el.suggestionsResults.appendChild(groupResults);
        }

        if (this.el.suggestionsResults.innerHTML === "") {
            this.toggleSuggestionsInfo(true);
            this.toggleSuggestionsResults(false);
        } else {
            this.toggleSuggestionsInfo(false);
            this.toggleSuggestionsResults(true);
        }
    }

}
